import { detectLanguage, getLanguageInstructions } from '../utils/languageDetection';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

// Get Firebase Functions instance
const getFirebaseFunctions = () => {
  try {
    const app = getApp();
    return getFunctions(app, 'us-central1');
  } catch (error) {
    console.error('Error getting Firebase Functions:', error);
    throw new Error('Firebase not initialized');
  }
};

export const generateFlashcardsWithAI = async (topic) => {
  try {
    // Detect the language of the input topic
    const detectedLanguage = detectLanguage(topic);
    const languageInstructions = getLanguageInstructions(detectedLanguage);

    // Call Firebase Cloud Function instead of OpenAI directly
    const functions = getFirebaseFunctions();
    const generateFlashcards = httpsCallable(functions, 'generateFlashcardsWithAI');

    const result = await generateFlashcards({
      topic,
      languageInstructions,
    });

    // The function returns the flashcards directly
    return result.data;
  } catch (error) {
    console.error('AI Generation Error:', error);
    
    // Handle Firebase Function errors
    if (error.code === 'functions/unauthenticated') {
      throw new Error('You must be logged in to generate flashcards with AI');
    } else if (error.code === 'functions/invalid-argument') {
      throw new Error('Invalid topic provided');
    } else if (error.code === 'functions/failed-precondition') {
      throw new Error('AI service is not configured. Please contact support.');
    } else if (error.code === 'functions/internal') {
      throw new Error(error.message || 'Failed to generate flashcards. Please try again.');
    } else {
      throw new Error(`Failed to generate flashcards: ${error.message}`);
    }
  }
};

export const generateFlashcardsFromDocument = async (documentText) => {
  try {
    // Detect the language of the document
    const detectedLanguage = detectLanguage(documentText);
    const languageInstructions = getLanguageInstructions(detectedLanguage);

    // Call Firebase Cloud Function instead of OpenAI directly
    const functions = getFirebaseFunctions();
    const generateFlashcards = httpsCallable(functions, 'generateFlashcardsFromDocument');

    const result = await generateFlashcards({
      documentText,
      languageInstructions,
    });

    // The function returns the flashcards directly
    return result.data;
  } catch (error) {
    console.error('AI Document Generation Error:', error);
    
    // Handle Firebase Function errors
    if (error.code === 'functions/unauthenticated') {
      throw new Error('You must be logged in to generate flashcards with AI');
    } else if (error.code === 'functions/invalid-argument') {
      throw new Error('Invalid document text provided');
    } else if (error.code === 'functions/failed-precondition') {
      throw new Error('AI service is not configured. Please contact support.');
    } else if (error.code === 'functions/internal') {
      throw new Error(error.message || 'Failed to generate flashcards from document. Please try again.');
    } else {
      throw new Error(`Failed to generate flashcards from document: ${error.message}`);
    }
  }
};